import { useCallback, useContext, useEffect, useState } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";
import moment from "moment";

import Pagination from "../../common/Pagination";
import RecordsPerPage from "../../common/RecordsPerPage";
import { AppContexts } from "../../../providers";

import FilterPanel from "../Common/FilterPanel";
import usePath from "../Common/History";

const ReplyLogs = () => {
  const [page, setPage] = useState(0);
  const [cookies] = useCookies(["records-per-page"]);
  const { "records-per-page": recordsPerPage = 20 } = cookies;

  const { active, replyLogs, startDate, endDate, getReplyLogs } = useContext(
    AppContexts.ReportsContext
  );

  const path = usePath();
  const { total = 0, paginated = [] } = replyLogs || {};

  useEffect(() => {
    if (path !== active) setPage(0);
  }, [path, active]);

  const getFn = useCallback(
    (start, end) => {
      if (!start || !end) return;
      getReplyLogs(start, end, page, recordsPerPage);
    },
    [page, recordsPerPage, getReplyLogs]
  );

  useEffect(() => {
    if (active === "reply-logs") getFn(startDate, endDate);
  }, [page, recordsPerPage, active, startDate, endDate, getFn]);

  const handlePageChange = useCallback((page) => setPage(page), []);

  const nameOnly = (s) => {
    const str = String(s ?? "").trim();
    return str ? str : "—";
  };

  const trunc = (s, n = 120) => {
    const str = String(s ?? "").trim();
    if (!str) return "—";
    return str.length > n ? str.slice(0, n) + "…" : str;
  };

  return (
    <li className="reports-tab-content">
      <h2>AI Suggested Replies</h2>

      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <FilterPanel onSubmit={getFn} />

        <table className="uk-table uk-table-hover uk-table-divider hms-table uk-margin-small-top">
          <thead>
            <tr>
              <th style={{ width: 170 }}>DATE</th>
              <th style={{ width: 220 }}>REQUESTED BY</th>
              <th style={{ width: 220 }}>GUEST NAME</th>
              <th>QUESTION</th>
              <th>SUGGESTED REPLY</th>
            </tr>
          </thead>

          <tbody>
            {paginated?.length ? (
              paginated.map((item) => (
                <tr key={item.id}>
                  <td>
                    {moment
                      .utc(item.created_at)
                      .local()
                      .format("MM/DD/YYYY hh:mm A")}
                  </td>

                  {/* USER = internal team member (from users table) */}
                  <td>{nameOnly(item.agent_name)}</td>

                  {/* GUEST = guest first/last (from reservation) */}
                  <td>{nameOnly(item.guest_name)}</td>

                  <td className="message">
                    <textarea rows={1} value={trunc(item.question, 220)} disabled />
                  </td>

                  <td className="message">
                    <textarea rows={1} value={trunc(item.answer, 260)} disabled />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="no-results">
                  No results for this date range
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Flex alignment="between top" className="guest-form-top-filters">
        <Pagination count={total} index={page} onIndexChanged={handlePageChange} />
        {total > 0 && <RecordsPerPage />}
      </Flex>
    </li>
  );
};

export default ReplyLogs;